module.exports = __webpack_public_path__ + "static/media/spinner.2ed69d50.svg";